import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The copy-beside-illustration frame that panes 2 through 8 share.
 *
 * Ported from koomzodesignsystem
 * `features/auth/components/walkthrough-slide` (kz2 F1).
 *
 * ---------------------------------------------------------------------------
 * A FRAME WITH TWO SLOTS, AND NO INPUTS AT ALL.
 *
 * "Shared shell, bespoke bodies." What this component owns is exactly what all
 * seven panes genuinely have in common: a two-column grid that is stacked below
 * `pane-split` (860px) and side-by-side at and above it, the copy column's
 * padding at three widths, and the divider that moves from `border-top` to
 * `border-left` in the same step. Everything else — what the copy says, what
 * the illustration is made of — is the pane's.
 *
 * It takes no configuration on purpose. The moment this component grows an
 * input describing what a body contains, it has become "one pane component
 * with eight configs" — the scout ruled that shape out by measurement: 8 of 8
 * panes differ structurally, 0 by content alone, and panes 3 and 4 split their
 * paragraph around the same chip at different points.
 *
 * PANE 1 DOES NOT USE THIS FRAME, and that is the design working rather than a
 * gap. It has no copy/viz split at all — it is a full-bleed primary page with
 * six stacked blocks. A body that will not fit the slot means the frame is
 * wrong for that body, not that the frame needs another option; so pane 1 sits
 * directly in the page's card and draws itself.
 * ---------------------------------------------------------------------------
 *
 * Both slots take MULTIPLE elements (`<div copy>`, `<h2 copy>`, `<p copy>`, …).
 * Angular projects every matching node into the one `ng-content`, which is what
 * keeps the copy column a real flex column with a real gap between its children
 * rather than one wrapper the pane would then have to lay out again.
 */
@Component({
  selector: 'app-walkthrough-slide',
  standalone: false,
  templateUrl: './walkthrough-slide.component.html',
  styleUrls: ['./walkthrough-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughSlideComponent {}
